// extracted by mini-css-extract-plugin
export default {"pageDashboardPreflightTailwindStyles":"preflight_pageDashboardPreflightTailwindStyles__kakyY"};